import { useEffect } from 'react';

import type { AppData } from '../types/app_data';

import { growthBookInstance } from './analytics/growthbook';
import { ABTestRedirectWebAppLoggedIn } from './enabled_features/ab_tests';
import { isGarageFlow } from './garage';

export const WEB_APP_PATH = '/webapp';
export const WEB_APP_QUOTES_PATH = '/webapp/quotes';

/**
 * Check if the partner is from GasBuddy.
 * @param partnerName
 */
export function isFromGasbuddy(partnerName?: string): boolean {
  return ['gasbuddy', 'gasbuddyapp', 'gasbuddyemail', 'gasbuddyalt'].includes(partnerName || '');
}

/**
 * Check if a user is eligible to be redirected to the web app.
 * TODO: Think of a better name after signup_existing_user_webapp since this is not the only place to redirect to web app.
 */
export function isUserEligibleToRedirectToWebApp(appData: AppData): boolean {
  // Do nothing if the user is from GasBuddy
  if (isFromGasbuddy(appData.partner?.partner)) {
    return false;
  }

  if (isGarageFlow(appData)) {
    return false;
  }

  return true;
}

/**
 * If the user has logged in WebApp, redirect them to the WebApp.
 */
export function useRedirectWebAppLoggedInUser(appData: AppData) {
  useEffect(() => {
    // Do nothing if the user is from GasBuddy
    if (isFromGasbuddy(appData.partner?.partner)) {
      return;
    }
    if (
      !appData.inviteV3DataInParams &&
      localStorage.getItem('WebAppActiveUser') &&
      growthBookInstance?.getFeatureValue(ABTestRedirectWebAppLoggedIn.storageKey, 0) === 1
    ) {
      window.location.href = WEB_APP_PATH;
    }
  }, [appData.inviteV3DataInParams, appData.partner?.partner]);
}
